export const TASK_TYPES = [
  {
    name: 'Inspection',
    type: 'INSPECTION',
  },
  {
    name: 'Observation',
    type: 'OBSERVATION',
  },
  {
    name: 'Incident',
    type: 'INCIDENT',
  },
  {
    name: 'Scheduled Inspection',
    type: 'SCHEDULE_INSPECTION',
  },
];
